<div class="navbar-container">
    @if(isHomePage) {
            <div class="navbar-home">
                <img
                src="assets/logos/QBuilt_logoBlk.png"
                alt="QBuilt_Logo"
                class="home-logo">
            </div>
    } @else {
        <div class="navbar">
            <button mat-icon-button class="home-button" (click)="goToHomePage()">
                <span class="material-symbols-outlined home-icon">
                    home
                </span>
            </button>
            <img style="height: 96.11px;"
            src="assets/logos/QBuilt_logoBlk.png"
            alt="QBuilt_Logo">
            <span style="margin-right: 30px;"></span>
        </div>
    }
</div>